import { ThemeUICSSObject } from '@apia/theme';

export const toolbar: ThemeUICSSObject = {
  alignItems: 'center',
  backgroundColor: 'palette.background.default',
  display: 'flex',
  gap: '2px',
  py: '4px',
  px: '8px',

  '& > *': {
    alignItems: 'center',
    borderRadius: '4px',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    outline: 'none !important',
    p: 0,
  },

  '.toolbar__textButton': (theme) => ({
    variant: 'buttons.primary-sm',
    background: 'transparent',
    border: 'none',
    color: 'palette.text.primary',

    ...theme.palette.getStatesFromDefinition(
      {
        backgroundColor: theme.palette.background.default,
      },
      { states: { default: false } },
    ),

    '&.primary': theme.palette.getStatesFromPath('buttons.primary'),
  }),

  '.toolbar__select': () => ({
    padding: '4px',
    paddingLeft: '8px',
    paddingRight: '32px',
  }),

  '.toolbar__button': {
    border: 'none',
    borderRadius: '4px',
    height: '32px',
    width: '32px',
    background: 'transparent',
    svg: {
      path: {
        fill: 'palette.text.primary',
      },
    },

    '&:disabled': {
      svg: {
        path: {
          fill: 'palette.border.section',
        },
      },
    },
  },

  '.fieldLabel': {
    display: 'flex',
    flexDirection: 'row',
    gap: 3,
    alignItems: 'center',
    justifyContent: 'center',
  },

  '.toolbar__input': {
    borderRadius: '4px',
    p: 3,
    width: '80px',
  },

  '.toolbar__separator': {
    borderLeft: '1px solid',
    borderRight: '1px solid',
    borderColor: 'palette.gray.750',
    height: '60%',
    width: '3px',
  },

  '.toggled': (theme) => {
    return {
      ...theme.palette.getOneState(
        { backgroundColor: theme.palette.background.default },
        'selected',
      ),
    };
  },
};
